<template>
  <path
    d="M11.33 3.60021L2.96998 11.1302C2.62998 11.4302 2.83998 12.0002 3.29998 12.0002H4.99998V19.0002C4.99998 19.5502 5.44998 20.0002 5.99998 20.0002H18C18.55 20.0002 19 19.5502 19 19.0002V12.0002H20.7C21.16 12.0002 21.38 11.4302 21.03 11.1302L12.67 3.60021C12.29 3.26021 11.71 3.26021 11.33 3.60021ZM12 16.0002C10.9 16.0002 9.99998 15.1002 9.99998 14.0002C9.99998 13.2202 10.99 11.5602 11.58 10.6402C11.78 10.3302 12.22 10.3302 12.42 10.6402C13.01 11.5602 14 13.2202 14 14.0002C14 15.1002 13.1 16.0002 12 16.0002Z"
  />
</template>
